import InputGroup from "./InputGroup";
import CoinIcon from "../../assets/images/icon.coin.svg";
import CloudIcon from "../../assets/images/icon.cloud.svg";
import CheckIcon from "../../assets/images/icon.check.black.svg";


const ProTierForm = ({showRecommend}) => {

    return (
        <InputGroup label={
            <>
                <div className="flex-align-center gap-2">
                    <div className="text-[32px] font-bold">Pro</div>
                    {
                        showRecommend && (
                            <div className="text-white font-semibold text-[16px] px-[12px] py-[6px] rounded-[80px] "
                                               style={{background: "linear-gradient(96.03deg, #1742DC -0.08%, #7621FF 99.92%)"}}>
                                추천
                            </div>)
                    }

                    <div className="text-[24px] text-primary font-semibold">₩50,000원 / 월</div>
                </div>
                <div className="text-quaternary font-medium">
                    중소규모의 회사에서 AI 메시지를 생성하고 자동 발송할 수 있습니다.
                </div>
            </>
        }>
            <div className="flex gap-[7px]">
                <div className="flex-col gap-2 bg-bluedepth rounded-[8px] px-[20px] py-[16px]">
                    <div className="text-[20px] font-bold">혜택</div>
                    <div className="flex-align-center gap-2">
                        <img src={CoinIcon} alt="coin" width="24" height="24" />
                        <div>가입 기념 5,000 크레딧 무료 제공 (2달내 사용)</div>
                    </div>
                    <div className="border-[1px]" style={{borderColor: "rgba(30, 14, 98, 0.08)"}}></div>
                    <div className="flex-align-center gap-2">
                        <img src={CloudIcon} alt="cloud" width="24" height="24" />
                        <div>최대 500개 제품 등록</div>
                    </div>
                </div>
                <div className="flex-1 flex-col gap-2 bg-shape rounded-[8px] px-[20px] py-[16px]">
                    <div className="text-[20px] font-bold">주요 기능</div>
                    <div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>Free 플랜의 모든 기능 +</div>
                        </div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>AI 캘린더 자동 발송</div>
                        </div>
                        <div className="flex-align-center gap-1">
                            <img src={CheckIcon} alt="check" width="14" height="14" />
                            <div>담당자 알림톡 발송</div>
                        </div>
                    </div>
                </div>
            </div>
        </InputGroup>
    )
}

export default ProTierForm;